import type { Employee } from './types'

export const mockEmployees: Employee[] = [
  {
    id: 'mock-employee-001',
    email: 'jan.de.vries@i4talent.nl',
    displayName: 'Jan de Vries',
    jobTitle: 'Senior Consultant',
    department: 'Consulting',
    managerId: 'mock-manager-001',
  },
  {
    id: 'mock-employee-002',
    email: 'marie.janssen@i4talent.nl',
    displayName: 'Marie Janssen',
    jobTitle: 'HR Business Partner',
    department: 'Human Resources',
    managerId: 'mock-manager-001',
  },
]

export const FALLBACK_EMPLOYEE: Employee = mockEmployees[0]!